/* eslint-disable */

export default {
  "signup": {
    "title": "Neues Konto erstellen",
    "subtitle": "oder melde Dich in Deinem Konto an",
    "tos": "Ich bin mit den Geschäftsbedingungen von Rele.ai einverstanden",
    "privacy": "Ich bin mit den Nutzungsbedingungen von Rele.ai einverstanden",
    "chooseMethod": "Ein Konto erstellen",
    "provideNumberDescription": "Hallo, bitte gib Deine Handynummer an, um Zugriff auf RELE.AI, Deine CRM-Assistentin, zu erhalten.",
    "createOrganizationDescription": "Bitte benenne Deine Firma. <br /> Nach der Erstellung kannst Du Dein CRM verbinden und Teammitglieder einladen.",
    "firstIntegrationDescription": "Verbinde RELE.AI mit einer der folgenden Integrationen. Du kannst es jederzeit ändern oder später auf der Integrationsseite weitere Integrationen hinzufügen."
  },
  "globals": {
    "search": "Suchen...",
    "hi": "Hallo,",
    "contactClara": "Kontaktiere RELE.AI",
    "page": "Seite",
    "month": "Monat",
    "year": "Jahr"
  },
  "payments": {
    "yearly": "Jahresabonnement",
    "monthly": "Monatsabonnement",
    "small": "Klein",
    "enterprise": "Firma",
    "smallDescription": "KMU Geschäft? Dieses Abonnement gilt für bis zu 100 Nutzern",
    "enterpriseDescription": "Mehr als 100 Nutzer? <br /> Nehmen Sie Kontakt auf",
    "planLayout_monthly": "Nutzer/Monat",
    "planLayout_yearly": "Nutzer/Jahr",
    "welcome": "Wir freuen uns sehr, Dich bei uns zu haben! 🥳 <br /> <br /> Wenn Du Hilfe benötigst, wende Dich einfach an <a href='mailto:support@rele.ai' class='text-r-primary'> support@rele.ai </ a>",
    "errorOnCheckout": "Es ist ein Fehler aufgetreten. <br /> <br /> Wir helfen Dir gerne weiter. Sende uns einfach eine E-Mail an <a href='mailto:support@rele.ai' class='text-r-primary'> support @ rele.ai </a>",
    "activeSubscription": {
      "dialogs": {
        "update": {
          "title": "Abonnementplan ändern",
          "description": "RELE.AI bietet Monats- und Jahrespläne an, die auf unserer <a href=\"https://rele.ai/pricing/\" target=\"_blank\" über class=\"text-r-primary\">Preisseite eingesehen werden können. </a><br /> Wenn Sie zwischen den Plänen wechseln möchten, wählen Sie einfach den gewünschten Plan aus der Dropdown-Liste aus und klicken Sie auf Speichern.",
          "plans": "Pläne"
        },
        "delete": {
          "title": "Abonnement kündigen",
          "description": "<div class=\"font-semibold\">Wir wollen nicht, dass Sie 😢</div><br />Sind Sie sicher, dass Sie Ihr Abonnement kündigen wollen?<br />Lassen Sie uns zuerst reden <a href='mailto:support@rele.ai' class=\"text-r-primary\">support@rele.ai</a>"
        }
      },
      "invoices": {
        "title": "Rechnungen",
        "created": "Datum der Rechnung",
        "amountPaid": "Bezahlter Betrag",
        "invoicePdf": "Rechnung herunterladen",
        "emptyItems": "Noch keine Rechnungen"
      },
      "subscriptionInfo": {
        "title": "Einzelheiten zum Abonnement",
        "startDate": "Startdatum",
        "plan": "Plan",
        "price": "{amount} {currency}/Benutzer/{interval}",
        "amountOfUsers": "Benutzer-Anzahl"
      }
    }
  },
  "usersManagement": {
    "user": "Nutzer",
    "table": {
      "name": "Mitarbeitername",
      "email": "Email Adresse",
      "phone": "Mobilnummer",
      "actions": "Aktionen",
      "title": "Benutzerverwaltung",
      "addNew": "Nutzer hinzufügen"
    },
    "deleteDialog": {
      "title": "Nutzer löschen",
      "description": "Bist Du sicher, dass Du {name} löschen möchtest?"
    }
  },
  "activeIntegrations": {
    "integration": "Integration",
    "table": {
      "title": "Aktive Integrationen",
      "noIntegrations": "Ups! <br /> Du hast keine aktive Integration. <br /> Bitte aktiviere eine der Integrationen und beginne mit der Dokumentation."
    }
  },
  "nonActiveIntegrations": {
    "title": "Marktplatz",
    "description": "Um eine der folgenden Integrationen zu aktivieren, klicke auf die Integrationskarte und folge den Anweisungen.",
    "hubspot": {
      "title": "Hubspot Integration",
      "description": "Integriere Dein Hubspot CRM-Konto und starte zu dokumentieren"
    },
    "salesforce": {
      "title": "Salesforce Integration",
      "description": "Integriere Dein Salesforce CRM-Konto und starte zu dokumentieren"
    },
    "mailing": {
      "title": "Email Integration",
      "description": "Integriere Dein Email-Konto und starte zu dokumentieren"
    },
    "noIntegrations": "Glückwunsch! <br /> Du hast alle Integrationen aktiviert."
  },
  "integrations": {
    "table": {
      "title": "Integrationen"
    },
    "crm": {
      "giveCarlaAccess": "Befolge diese Schritte, um RELE.AI zu verbinden",
      "title": "CRM Integrationen",
      "noCrmConnections": "Du hast RELE.AI noch keinen Zugriff auf Dein CRM gegeben.",
      "connectCrm": "CRM verbinden",
      "apiKey": "API Schlüssel:",
      "updateConnection": "Bearbeiten",
      "selectCRM": "Ein CRM wählen",
      "salesforce": {
        "guide": "<ol class = \"list-decimal\"> <li> Melde Dich bei Salesforce an, indem Du auf die Schaltfläche unten klickst. </ li> <li> Genehmige den Zugriff auf RELE.AI </ li> </ ol>",
        "releaiPackage": "<div>• Bevor Du Dich bei Salesforce anmeldest, musst Du Dein Salesforce-Konto mit der RELE.AI Salesforce-App verknüpfen. <br /><div style='margin-top: 10px;'>• Erkundige Dich bei Deinem Salesforce-Administrator, ob die App bereits installiert ist. Wenn sie nicht installiert ist, kannst Du sie installieren, indem Du <a style='color: blue;' href=\"https://login.salesforce.com/packaging/installPackage.apexp?p0=04t3z000001zs7p\" target=\"_blank\">hier</a> klickst.</div><div style='margin-top: 10px;'>• Für mehr Informationen: <a style='color: blue;' href=\"https://rele.ai/how-to-connect-salesforce/\" target=\"_blank\">https://rele.ai/how-to-connect-salesforce</a></div></div>"
      },
      "hubspot": {
        "chooseAuth": {
          "oauth": "Melde Dich mit Hubspot an",
          "apiKey": "API Schlüssel",
          "chooseAuthMethodTitle": "Welche Authentifizierungs-Methode für Hubspot soll ich wählen?",
          "chooseAuthMethodDesc": "<div>Durch Herstellen einer Verbindung zu Hubpost mithilfe des <span style='font-weight: 800'>API-Schlüssels</span>, <span style='font-weight: 800'>erhalten alle Benutzer</span> die Sie unter der RELE.AI-Konsole hinzufügen, die Berechtigung, Hubpsot über RELE.AI zu verwenden.<div style='margin-top: 5px;'>Wenn Sie über <span style='font-weight: 800'>'Anmelden mit HubSpot'</span> eine Verbindung zu Hubpost herstellen, geben Sie ausschliesslich Ihren Benutzern die Berechtigung, Hubpsot über RELE.AI zu verwenden.</div></div>",
          "title": "Wähle die Authentifizierungs-Methode",
          "description": "Bitte wähle die Verbindung zu Hubspot aus. Du kannst wählen, ob Du eine Verbindung mit dem API-Schlüssel Deines Hubspot-Kontos oder mit der OAuth-Anmeldung herstellen möchtest.",
          "tooltips": {
            "oauth": "<div>Bitte beachten Sie, dass Sie Ihre Teammitglieder (RELE.AI Nutzer) darüber informieren müssen, dass sie die folgenden Schritte ausführen müssen: <br /> 1. Besuchen Sie console.rele.ai <br /> 2. Besuchen Sie den Abschnitt Integrationen <br /> 3. Wählen Sie HubSpot <br /> 4. Melden Sie sich mit dem HubSpot Login an</div>"
          }
        },
        "guideOauth": "<ol class = \"list-decimal\"> <li> Melde Dich bei Hubspot an, indem Du auf die Schaltfläche unten klickst. </ li> <li> Genehmige den Zugriff auf RELE.AI </ li> </ ul>",
        "guideApiKey": "<ol class = \"list-decimal\"> <li> Melde Dich bei Deinem HubSpot-Konto an. </ li> <li> Greife auf die Hubspot-Einstellungen zu, indem Du auf Dein Profil klickst -> Profil & Einstellungen </ li> <li> Gehe im linken Menü zu Integrationen -> API-Schlüssel </ li> <li> Kopiere den API-Schlüssel und füge ihn in die Eingabe unten </ li> </ ul> ein",
        "docs": {
          "part1": "Nicht gefunden? Bitte besuche",
          "link": "diesen",
          "part2": "Link für weitere Erklärungen"
        }
      },
      "deleteDialog": {
        "title": "Integration löschen",
        "description": "Bist Du sicher, dass Du die {name} Integration löschen möchtest?"
      }
    },
    "mailing": {
      "guide": "Ermögliche den Zugriff zum Senden von E-Mails, indem Du auf das Kontrollkästchen klickst.",
      "checkbox": {
        "enable": "Mailing ist aktiviert",
        "disable": "Mailing ist deaktiviert",
        "disableInfo": "Bitte füge Deinem Konto eine E-Mail-Adresse hinzu, um Mailing zu aktivieren."
      }
    }
  },
  "notifications": {
    "trailEndIn": "Deine Testversion endet in {Tage}. Bitte vervollständige die Angaben Deiner Zahlung. 🤑",
    "editSuccess": "Gratuliere! Du hast {name} aktualisiert",
    "createSuccess": "Gratuliere! Du hast {name} eröffnet"
  },
  "forms": {
    "firstname": "Vorname",
    "lastname": "Nachname",
    "email": "Email Adresse",
    "mobile": "Mobilnummer",
    "workspace": "Firmasname",
    "botLang": "Bevorzugte Bot-Sprache",
    "claraNumber": "Bevorzugte Bot-Nummer",
    "password": "Passwort"
  },
  "buttons": {
    "continueWithGoogle": "Mit Google fortfahren",
    "continueWithMicrosoft": "Mit Microsoft fortfahren",
    "next": "weiter",
    "back": "zurück",
    "getStarted": "weiter",
    "edit": "bearbeiten",
    "save": "speichern",
    "delete": "löschen",
    "cancel": "abbrechen",
    "signOut": "ausloggen",
    "continueWithSalesforce": "Mit Salesforce fortfahren",
    "continueWithHusbpot": "Mit Hubspot fortfahren",
    "botSettings": "Bot-Einstellungen",
    "consoleSettings": "Console-Einstellungen",
    "close": "schliessen",
    "continueWithEmail": "Weiter mit Email",
    "cancelSubscription": "Abonnement kündigen",
    "changePlan": "Plan ändern",
    "deleteCompany": "Firma löschen",
  },
  "errors": {
    "unableToAuthenticateTitle": "Authentifizierung kann nicht abgeschlossen werden",
    "missingRequiredField": "Fehlende Pflichtfelder",
    "unableToCreateUser": "Benutzer kann nicht erstellt werden",
    "workspaceNameRequired": "Workspace-Name ist erfordert",
    "unableToCreateNewOrg": "Firma kann nicht erstellt werden",
    "unableToUpdateUserWithOrgId": "Der Benutzer kann nicht an die Firma angehängt werden",
    "validateEmail": "Ungültige Email Adresse. Bitte gib eine gültige Email Adresse ein.",
    "validateFirstName": "Ungültiger Vorname. Bitte gib einen gültigen Vornamen ein.",
    "validateLastName": "Ungültiger Nachname. Bitte gib einen gültigen Nachnamen ein.",
    "unableToDeleteUser": "Benutzer kann nicht gelöscht werden",
    "unableToLoginWithSalesforce": "Anmeldung mit Salesforce nicht möglich.",
    "unableToLoginWithHubspot": "Anmeldung mit Hubsport nicht möglich.",
    "unableToEnableMailing": "Email kann nicht integriert werden",
    "unableToCreatePaymentSubscription": "Zahlung nicht möglich.",
    "unableToDeleteIntegration": "Integration löschen nicht möglich.",
    "unableToSaveBotSettings": "Speichern der Bot-Einstellungen nicht möglich",
    "unableToChangeSubscription": "Der Abonnementsplan kann nicht geändert werden.",
    "unableToCancelSubscription": "Abonnement kann nicht gekündigt werden. Bitte kontaktieren Sie unser Support-Team.",
    "validateMobile": "Es gibt einen bestehenden Benutzer mit der gleichen Nummer."
  },
  "placeholders": {
    "enterYourEmail": "Gib Deine Email Adresse ein",
    "enterYourPassword": "Gib Dein Passwort ein"
  },
  "botOptions": {
    "inherit": "Standard-Firmassprache",
    "en": "Englisch",
    "es": "Spanisch",
    "fr": "Französisch",
    "gr": "Deutsch",
    "pt": "Portugiesisch"
  },
  "botSettings": {
    "title": "Bot-Einstellungen"
  },
  "deleteCompany.title": "Firma löschen"
}